import React from 'react'
import { Col, Row } from 'reactstrap'
type IProps ={
  classWise? :boolean
}
const TableHeader = ({classWise =false}:IProps) => {
  return (
    <Row className='mx-2 mt-3' style={{backgroundColor:"#0B5394"}}>
                     <Col className={`border-right text-white text-center text-lg p-2 ${classWise ? `col-5` :``} `}>Metric</Col>
                    { classWise ?  <>
                                <Col className='border-right text-white text-center text-lg p-2'>Class 10</Col>
                                <Col className='border-right text-white text-center text-lg p-2'>Class 11</Col>
                                <Col className='border-right text-white text-center text-lg p-2'>Class 12</Col>
                                <Col className='text-white text-center text-lg p-2'>Overall</Col>
                                </>
                    :<Col className='  text-white text-center text-lg p-2'>Overall</Col>} 
     </Row>
  )
}

export default TableHeader
